
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import { AuthEnum } from '@/services/permission.service';
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

@Component({})
export default class PartialRefoundPopover extends Vue {
  clicked = false;

  AuthEnum = AuthEnum;

  visible = false;

  @Ref('formRef')
  formRef!: FormModel;

  @Prop({
    default: '',
  })
  orderNo!: string;

  @Prop({
    default: {},
  })
  payPrice!: any;

  @Prop()
  payStatusStr!: string;

  dragReset: any = null;

  @Watch('visible', { immediate: true })
  visibleDragReset() {
    if (this.visible) return;
    if (this.dragReset) {
      this.dragReset();
    }
  }

  handleDragReset(resetFn: any) {
    this.dragReset = resetFn;
  }

  refundablePrice: any = 0;

  refundAmount = 0;

  refundNum = 0;

  formData = {
    amount: '',
    reason: '',
    part: undefined,
  };

  labelCol = { span: 4 };
  wrapperCol = { span: 14 };
  rules = {
    part: [{ required: true, message: '请选择退款类型' }],
    amount: [
      { required: true, message: '请输入退款金额' },
      {
        validator: this.validatorAmount,
      },
    ],
    reason: [{ required: true, message: '请输入退款原因' }],
  };

  validatorAmount(rule: any, value: any, callback: any) {
    if (+value < 0.01) {
      callback(new Error('退款金额不能小于0'));
    } else if (+value > this.refundablePrice) {
      console.log(this.refundablePrice);
      callback(new Error('退款金额不能大于订单可退金额'));
    } else {
      callback();
    }
  }

  @lazyInject(CarService)
  carService!: CarService;

  modelClick() {
    this.refundablePrice = this.payPrice;
    console.log(this.payStatusStr);
    if (this.payStatusStr === '部分退款') {
      this.getAudioManager();
    } else {
      this.visible = true;
    }
  }

  async getAudioManager() {
    const data = {
      order_no: this.orderNo,
    };
    const res: any = await this.carService.getBackgroundAudioManager(data);
    console.log(res);
    const refundAmount = (res.amount as number) - (res.refund_amount as number);
    console.log(refundAmount);
    this.refundablePrice = refundAmount;
    this.refundAmount = res.refund_amount;
    this.refundNum = res.refund_num;
    console.log(this.refundablePrice);
    this.visible = true;
  }

  changePart() {
    if (this.formData.part === 0) {
      this.formData.amount = this.refundablePrice;
    } else {
      this.formData.amount = '';
    }
  }

  handleClickChange(visible: boolean) {
    this.clicked = visible;
  }

  handleClick() {
    this.formRef.resetFields();
    this.refundNum = 0;
    this.refundAmount = 0;
    this.visible = false;
  }

  /** 退款确认 */
  async refund(id: string, data: any) {
    const params = Object.assign(data, { order_no: id });
    const res = await this.carService.postShopOrderRefund(params);
    if (!res) {
      return;
    }
    this.$message.success(res);
    this.clicked = false;
    this.visible = false;
    this.refundNum = 0;
    this.refundAmount = 0;
    this.$emit('refresh', true);
  }

  handleOk() {
    this.formRef.validate((valid) => {
      if (valid) {
        this.$confirm({
          title: '操作确认',
          content: `退款金额为${this.formData.amount}元,确认操作退款吗?`,
          onOk: async () => {
            await this.refund(this.orderNo, this.formData);
          },
          onCancel() {},
          class: 'test',
        });
      }
    });
  }
}
